//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import { mapActions, mapGetters } from "vuex";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import { date } from "quasar";
import { APP_DATE_SLASH } from "@/assets/js/appConfig";

export default {
    name: "ExportAuditPanel",
    components: {
        AQButton,
        AQInput
    },
    props: {
        columns: { type: Array, default: () => [] },
        entityCode: { type: String, default: "" }
    },
    data() {
        return {
            panelOpen: false,
            selectedColumns: [],
            fromDate: "",
            toDate: "",
            dateFormat: "DD.MM.YYYY",
            fromDateErr: false,
            toDateErr: false,
            myLocaleRo: {
                days: "Du_Lu_Ma_Mi_Joi_Vi_Sâ".split("_"),
                daysShort: "Du_Lu_Ma_Mi_Joi_Vi_Sâ".split("_"),
                months: "Ian_Feb_Mar_Apr_Mai_Iun_Iul_Aug_Sep_Oct_Nov_Dec".split("_"),
                monthsShort: "Ian_Feb_Mar_Apr_Mai_Iun_Iul_Aug_Sep_Oct_Nov_Dec".split("_"),
                firstDayOfWeek: 1
            }
        };
    },

    computed: {
        ...mapGetters("userProfile", ["userDataDetails"]),
        myLocale() {
            let localeToReturn = null;
            if (this.userDataDetails && this.userDataDetails.language === "ro") {
                localeToReturn = this.myLocaleRo;
            }
            return localeToReturn;
        },
        setFromDateProps() {
            return {
                options: this.optionsFromDate,
                noTimeOptions: true,
                locale: this.myLocale
            };
        },
        setToDateProps() {
            return {
                options: this.optionsToDate,
                noTimeOptions: true,
                locale: this.myLocale
            };
        }
    },
    methods: {
        ...mapActions("dataStore", ["exportAuditData"]),
        cancel() {
            this.$emit("closePanel");
        },
        exportData() {
            const payload = {
                entityCode: this.entityCode,
                from: date.formatDate(new Date(this.fromDate), "YYYY-MM-DDTHH:mm:ssZ"),
                to: date.formatDate(new Date(this.toDate), "YYYY-MM-DDTHH:mm:ssZ")
            };

            this.exportAuditData(payload).then(() => {
                this.$toast.showNotify({
                    type: "info",
                    message: this.$t("dataTable.exportNotification"),
                    hasClose: false
                });
            });

            this.cancel();
        },
        optionsToDate(data) {
            let valid = true;
            if (this.fromDate) {
                const fromDate = date.formatDate(this.fromDate, APP_DATE_SLASH);
                let oneMonthLater = date.addToDate(new Date(this.fromDate), { month: 1 });
                oneMonthLater = date.formatDate(oneMonthLater, APP_DATE_SLASH);
                valid = data > fromDate && data < oneMonthLater;
            }
            return valid;
        },
        optionsFromDate(data) {
            let valid = true;
            if (this.toDate) {
                const toDate = date.formatDate(this.toDate, APP_DATE_SLASH);
                let oneMonthEarlier = date.subtractFromDate(new Date(this.toDate), { month: 1 });
                oneMonthEarlier = date.formatDate(oneMonthEarlier, APP_DATE_SLASH);
                valid = data < toDate && data > oneMonthEarlier;
            }
            return valid;
        }
    }
};
